import React from "react";
import { Tooltip } from "@mui/material";
import { CrossIcon, PlusIcon } from "../../../../components/Icons";
import { colors } from "../../../../theme/colors";
import {
  EditChipsContainer,
  EditChip,
  EditChipRemove,
  EditAddButton,
} from "./TreatmentStepChips.styled";

interface TreatmentStepEditChipsProps {
  values: string[];
  onRemove: (value: string) => void;
  onAddClick: () => void;
  addButtonVariant?: "code" | "icon";
  addButtonLabel?: string;
  disabled?: boolean;
  disabledReason?: string;
}

const TreatmentStepEditChips: React.FC<TreatmentStepEditChipsProps> = ({
  values,
  onRemove,
  onAddClick,
  addButtonVariant = "icon",
  addButtonLabel,
  disabled = false,
  disabledReason,
}) => {
  const addButton = (
    <EditAddButton
      type="button"
      variant={addButtonVariant}
      aria-label={addButtonLabel || "Add"}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        if (disabled) return;
        onAddClick();
      }}
    >
      {addButtonVariant === "icon" ? (
        <PlusIcon
          width="14px"
          height="14px"
          fill={disabled ? colors.text.secondary : colors.border.medium}
        />
      ) : (
        addButtonLabel
      )}
    </EditAddButton>
  );

  return (
    <EditChipsContainer>
      {values.map((value) => (
        <EditChip key={value}>
          <span>{value}</span>
          <EditChipRemove
            type="button"
            aria-label={`Remove ${value}`}
            onClick={(event) => {
              event.stopPropagation();
              onRemove(value);
            }}
          >
            <CrossIcon width="10px" height="10px" />
          </EditChipRemove>
        </EditChip>
      ))}
      {disabled && disabledReason ? (
        <Tooltip title={disabledReason} arrow placement="top">
          <span>{addButton}</span>
        </Tooltip>
      ) : (
        addButton
      )}
    </EditChipsContainer>
  );
};

export default TreatmentStepEditChips;
